export const onRuleReload = () => {
  if (typeof window !== 'undefined') {
    window.location.reload()
  }

  return {
    isReload: true,
  }
}
